import { createContext, useContext } from "react";

interface NotificationsContextValue {
  unreadMessages: number;
  markMessagesSeen: () => void | Promise<void>;
}

export const NotificationsContext = createContext<NotificationsContextValue>({
  unreadMessages: 0,
  markMessagesSeen: () => undefined,
});

export const useNotificationsCtx = () => useContext(NotificationsContext);
